// The iOS app's illustrations, exported for the web so both apps draw the
// same pictures in the same places. The files are 128px WebP copies of
// `ios/Cognify/Assets.xcassets`; regenerate them from there, not by hand.

import androidLogo from "./android_logo.webp";
import check from "./check.webp";
import diamond from "./diamond.webp";
import gold from "./gold.webp";
import golds from "./golds.webp";
import instagram from "./instagram.webp";
import tiktok from "./tiktok.webp";
import chatBubble from "./chat_bubble.webp";
import excel from "./excel.svg";
import folders from "./folders.webp";
import framePicture from "./frame_picture.webp";
import goldMindmap from "./gold_mindmap.png";
import goldQcm from "./gold_qcm.webp";
import mic from "./mic.webp";
import note from "./note.webp";
import openFolder from "./open_folder.webp";
import pdf from "./pdf.webp";
import ppt from "./ppt.webp";
import word from "./word.webp";

export const ART = {
  androidLogo,
  chatBubble,
  check,
  diamond,
  folders,
  gold,
  goldMindmap,
  goldQcm,
  golds,
  instagram,
  note,
  openFolder,
  tiktok,
};

// The animated Microsoft Teams emoji iOS draws through `AnimatedImage`.
// iOS bundles some of them; the web loads them from the same CDN it
// already uses for the generation hourglass.
const TEAMS = "https://em-content.zobj.net/source/microsoft-teams";

export const EMOJI = {
  books: `${TEAMS}/363/books_1f4da.png`,
  cameraFlash: `${TEAMS}/363/camera-with-flash_1f4f8.png`,
  cardIndex: `${TEAMS}/363/card-index-dividers_1f5c2-fe0f.png`,
  detective: `${TEAMS}/363/man-detective_1f575-fe0f-200d-2642-fe0f.png`,
  hourglass: `${TEAMS}/363/hourglass-done_231b.png`,
  spiralNotepad: `${TEAMS}/363/spiral-notepad_1f5d2-fe0f.png`,
  student: `${TEAMS}/337/student_1f9d1-200d-1f393.png`,
  studioMic: `${TEAMS}/363/studio-microphone_1f399-fe0f.png`,
  technologist: `${TEAMS}/337/man-technologist_1f468-200d-1f4bb.png`,
  thumbsUp: `${TEAMS}/337/thumbs-up_1f44d.png`,
  wastebasket: `${TEAMS}/363/wastebasket_1f5d1-fe0f.png`,
  writingHand: `${TEAMS}/363/writing-hand_270d-fe0f.png`,
};

/** The document icon iOS shows for an attached file, by extension. */
export function fileArt(nameOrExt) {
  const ext = String(nameOrExt || "").split(".").pop().toLowerCase();
  if (ext === "pdf") return pdf;
  if (["doc", "docx", "rtf", "odt"].includes(ext)) return word;
  if (["xls", "xlsx", "csv"].includes(ext)) return excel;
  if (["ppt", "pptx", "key"].includes(ext)) return ppt;
  if (["png", "jpg", "jpeg", "heic", "heif", "webp", "gif"].includes(ext)) return framePicture;
  if (["mp3", "m4a", "wav", "aac", "ogg"].includes(ext)) return mic;
  return note;
}
